import journeyService from "@/services/journey";
import store from "@/state/store";

import router from "../../router/index";

export const state = {
  journeyList: [],
  journeys: [],
  journeysRemote: [],
  loading: false,
  selectedJourney: null,
  journeyDetails: null,
  journeyUserTypes: null,
  journeyInputs: [],
  qrUserTypes: [],
  checks:[],
  registrationNotRequiredCount:0,
  isValidateRemoteJourney: true,
};

export const actions = {
  fetchJourneyList({ commit }) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneys()
        .then((data) => {
          resolve(data);
          commit("setJourneyList", data.data);
          commit("setSelectedJourney", null);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchJourneys({ commit }) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneys()
        .then((data) => {
          resolve(data);
          commit("setJourneys", data.data);
          commit("setSelectedJourney", null);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("setLoading", false);
        });
    });
  },
  fetchJourneyNormalList({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneysNormal(siteId)
        .then((data) => {
          resolve(data);
          commit("setJourneys", data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchJourneyFlows({commit}, site_ids) {
    console.log(site_ids)
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneyFlows(site_ids)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchJourneyFlowsDetails({commit}, journeyFlow_id) {
    console.log(journeyFlow_id)
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneyFlowsDetails(journeyFlow_id)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchJourneyRemoteList({ commit }, siteId) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneysRemote(siteId)
        .then((data) => {
          resolve(data);
          commit("setJourneyRemoteList", data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchQRUserTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      journeyService
        .qrUserTypes(payload)
        .then((data) => {
          resolve(data);
          console.log('qruserypes', data, data.data);
          commit("setQRUserTypes", data.data);
          // commit("setSelectedJourney", null);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("setLoading", false);
        });
    });
  },
  fetchJourneyChecks({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      journeyService.getJourneyChecks(payload).then(res => {
        resolve(res)
        commit('setJourneyChecks', res.data)
        commit('setLoading', false);
      })
        .catch(err => {
          reject(err)
          commit("setLoading", false)
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        })
    })
  },
  createJourney({ commit }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      journeyService
        .createJourney(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Journey Created");
          commit("setSelectedJourney", data.data);
          router.push(`/add/journey/flow/${data.data.id}`);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchUserTypeRelatedToJourney({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      journeyService
        .getUserTypeRelatedToJourney(id)
        .then((data) => {
          resolve(data);
          commit("setJourneyUserTypes", data.data);
          dispatch('fetchJourneyDetails', id);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchRegistrationNotRequiredUserTypeCount({ commit }, journeyId) {
    return new Promise((resolve, reject) => {
      journeyService
        .getRegistrationNotRequiredUserTypeCount(journeyId)
        .then((data) => {
          resolve(data);
          commit("setRegistrationNotRequiredCount", data.data);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  validateRemoteJourney({ commit }, payload) {
    return new Promise((resolve, reject) => {
      journeyService
        .validateRemoteJourney(payload)
        .then((data) => {
          resolve(data);
          commit("setIsValidateRemoteJourney", data.data);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchJourneyInputs({ commit }, id) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneyInputs(id)
        .then((data) => {
          resolve(data);
          commit("setJourneyInputs", data.data);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchJourneyDetails({ commit }, id) {
    return new Promise((resolve, reject) => {
      journeyService
        .getJourneyDetails(id)
        .then((data) => {
          resolve(data);
          console.log('fetch', data.data);
          commit("setJourneyDetails", data.data);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  deleteJourney({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      journeyService
        .deleteJourney(id)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Journey Deleted");
          dispatch("journeyBuilder/fetchJourneys", null, { root: true });
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  updateJourney({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      journeyService
        .updateJourney(params.formData, params.journey_id)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Journey Updated");
          commit("setLoading", false);
          router.push('/journeys');
        })
        .catch((err) => {
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  changeJourney({ commit }, payload) {
    commit("setLoading", true);
    return new Promise((resolve) => {
      journeyService
        .changeJourney(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          // router.push('/journeys');
          store.dispatch("sites/fetchAreasFilter", {
            id: router.history.current.params.id,
          });
        })
        .catch((err) => {
          commit("setLoading", false);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  }
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setJourneyList(state, payload) {
    state.journeyList = payload;
  },
  setJourneys(state, payload) {
    state.journeys = payload;
  },
  setJourneyRemoteList(state, payload) {
    state.journeysRemote = payload;
  },
  setSelectedJourney(state, payload) {
    state.selectedJourney = payload;
  },
  setJourneyDetails(state, payload) {
    state.journeyDetails = payload;
  },
  setJourneyUserTypes(state, payload) {
    state.journeyUserTypes = payload;
  },
  setJourneyInputs(state, payload) {
    state.journeyInputs = payload;
  },
  setQRUserTypes(state, payload) {
    state.qrUserTypes = payload;
  },
  setJourneyChecks(state, payload) {
    state.checks = payload;
  },
  setRegistrationNotRequiredCount(state, payload) {
    state.registrationNotRequiredCount = payload
  },
  setIsValidateRemoteJourney(state, payload) {
    state.isValidateRemoteJourney = payload
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getJourneyList(state) {
    return state.journeyList;
  },
  getJourneys(state) {
    return state.journeys;
  },
  getJourneyRemoteList(state) {
    return state.journeysRemote;
  },
  getSelectedJourney(state) {
    return state.selectedJourney;
  },
  getJourneyDetails(state) {
    return state.journeyDetails;
  },
  getJourneyUserTypes(state) {
    return state.journeyUserTypes;
  },
  getJourneyInputs(state) {
    return state.journeyInputs;
  },
  getQRUserTypes(state) {
    return state.qrUserTypes;
  },
  getJourneyChecks(state) {
    return state.checks;
  },
  getRegistrationNotRequiredCount(state) {
    return state.registrationNotRequiredCount
  },
  getIsValidateRemoteJourney(state) {
    return state.isValidateRemoteJourney;
  },
};
